// BrandModal.jsx - Updated to handle image file upload
import React, { useState, useEffect } from 'react';

export const BrandModal = ({ show, onClose, onSubmit, isEdit, currentItem }) => {
    const [formData, setFormData] = useState({ name: '', imageFile: null });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (isEdit && currentItem) {
            setFormData({ name: currentItem.name, imageFile: null });
        } else {
            setFormData({ name: '', imageFile: null });
        }
    }, [isEdit, currentItem]);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Required';
        if (!isEdit && !formData.imageFile) newErrors.image = 'Required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            const submitData = new FormData();
            submitData.append('name', formData.name);
            if (formData.imageFile) {
                submitData.append('image', formData.imageFile);
            }
            if (isEdit && currentItem) {
                submitData.append('id', currentItem.id);
            }
            onSubmit(submitData);
        }
    };

    const handleNameChange = (e) => {
        setFormData({ ...formData, name: e.target.value });
    };

    const handleImageChange = (e) => {
        setFormData({ ...formData, imageFile: e.target.files[0] });
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded max-w-md w-full mx-4">
                <h2 className="text-xl font-bold mb-4">{isEdit ? 'Edit Brand' : 'Add Brand'}</h2>
                <form onSubmit={handleSubmit}>
                    <input name="name" value={formData.name} onChange={handleNameChange} placeholder="Name" className="w-full p-2 border mb-2" />
                    {errors.name && <p className="text-red-500 text-sm mb-2">{errors.name}</p>}

                    {isEdit && currentItem.image && (
                        <div className="mb-2">
                            <label className="block text-sm font-medium mb-1">Current Image</label>
                            <img src={currentItem.image} alt="Current Brand" className="w-20 h-20 object-cover mb-2" />
                        </div>
                    )}

                    <div className="mb-2">
                        <label className="block text-sm font-medium mb-1">New Image (optional for edit)</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="w-full p-2 border"
                        />
                        {(!isEdit && errors.image) && <p className="text-red-500 text-sm">{errors.image}</p>}
                    </div>

                    <div className="flex justify-end space-x-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">{isEdit ? 'Update' : 'Add'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};